import { DataSchemaItemFragment } from 'generated/resources/graphql'
import { camelCase } from 'lodash'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

interface Props {
  dataSchemaItem?: DataSchemaItemFragment
  value: string | unknown
  onChange: (fieldName: string, value: string) => void
  mandatory?: boolean
  error?: string
  legalEntityId?: number
  country?: string
}

export const EnumField = ({
  dataSchemaItem,
  value,
  onChange,
  mandatory,
  error,
  legalEntityId,
  country,
}: Props) => {
  if (!dataSchemaItem) {
    return null
  }

  let allowedValues = dataSchemaItem.allowedValues ?? []
  if (legalEntityId) {
    allowedValues = allowedValues.filter(
      (option) => !option.legalEntityIds || option.legalEntityIds?.includes(legalEntityId)
    )
  }
  if (!!country && dataSchemaItem.fieldName !== 'legal_entity_id') {
    allowedValues = allowedValues.filter((option) => !option.country || option.country === country)
  }

  if (!allowedValues.length) return null

  return (
    <Selector.Popover
      blankLabel={i18n.t('employee_form.payroll_data.select_an_option')}
      placeholder={i18n.t('employee_form.payroll_data.select_an_option')}
      searchPlaceholder={dataSchemaItem.label}
      inputStyle="badge"
      label={dataSchemaItem.label}
      onChange={(newValue) =>
        onChange(camelCase(dataSchemaItem.fieldName), newValue ? String(newValue) : '')
      }
      value={value ? [value] : []}
      isMultiSelect={false}
      mandatory={mandatory}
      error={error}
    >
      {allowedValues.map((allowedValue) => (
        <Selector.Option
          key={allowedValue.key}
          value={allowedValue.key}
          label={allowedValue.value}
          searchValue={allowedValue.value}
        >
          {allowedValue.value}
        </Selector.Option>
      ))}
    </Selector.Popover>
  )
}
